import React from 'react';

const TagList = ({ tags }) => {
  return (
    <div className="flex flex-wrap gap-2">
      {tags.map((tag, index) => (
        <span
          key={index}
          // En oscuro, rosa claro sobre un fondo rosa más opaco: con el mismo
          // tinte del claro (14 %) casi no se leía sobre el gris de la tarjeta.
          className="px-2.5 py-0.5 rounded-full text-[12px] font-medium max-w-xs break-all bg-rose-500/10 text-rose-600 dark:bg-rose-500/25 dark:text-rose-200"
        >
          {tag}
        </span>
      ))}
    </div>
  );
};

export default TagList;
